import LibrariesSelect from "components/LibrariesSelect";
import React, { useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import api from "service/api";
import { toast } from "react-toastify";
import Select from "react-select";
import { CookieTool } from "utils/CookieTool";

function LibraryMatchingFields({ back }) {
  const { setValue, watch, control, formState } = useFormContext();
  const [segments, setSegments] = useState([]);
  const [loadingSegments, setLoadingSegments] = useState(false);
  const permissions = CookieTool.getLarge("permissions");
  const { errors, isSubmitted } = formState;
  const selectedLibraries = watch("libraries", []) || [];
  const selectedClient = watch("client");

  const handleLibraryChange = (sel) => {
    const libs = sel || [];
    setValue("libraries", libs);
  };

  const handleCreateLibrary = () => {
    if (selectedClient && selectedClient.id) {
      window.open(
        `/admin/library-form?clientId=${selectedClient.id}`,
        "_blank",
      );
    }
  };

  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      setLoadingSegments(true);
      api
        .get(
          `/segments?page=1&client=${selectedClient.id}&limit=${new Date().getTime()}`,
        )
        .then((response) => response.data)
        .then((response) => {
          setSegments(
            response.segments.map((item) => ({
              label: item.title,
              value: item.id,
              id: item.id,
              name: item.title,
            })),
          );
        })
        .catch(() => {
          toast.error("Erro ao recuperar segmentos!");
        })
        .finally(() => setLoadingSegments(false));
    }
  }, [selectedClient, setValue]);

  return (
    <div className="mb-3">
      <div>
        <label className="form-control-label">Segmento</label>
        <Controller
          name="segment"
          control={control}
          rules={{
            required: { value: true, message: "O segmento é obrigatório." },
          }}
          render={({ field }) => (
            <Select
              {...field}
              options={segments}
              isLoading={loadingSegments}
              placeholder={
                loadingSegments
                  ? "Carregando segmentos..."
                  : "Selecione um segmento"
              }
              isDisabled={!selectedClient || loadingSegments}
              onChange={(option) =>
                field.onChange(
                  option ? { id: option.id, name: option.name } : null,
                )
              }
              value={segments.find((opt) => opt.id === field.value?.id) || null}
              required
              isClearable
            />
          )}
        />
        {isSubmitted && errors.segment && (
          <small className="text-danger" style={{ fontSize: "0.85em" }}>
            {errors.segment.message}
          </small>
        )}
      </div>
      <label className="form-control-label">Bibliotecas</label>
      {permissions.includes("create:library") && (
        <button
          type="button"
          className="btn btn-sm btn-primary ml-2"
          onClick={handleCreateLibrary}
          disabled={!selectedClient || !selectedClient.id}
          title="Criar nova biblioteca"
          style={{ width: "30px", height: "30px", padding: 0 }}
        >
          +
        </button>
      )}
      <LibrariesSelect
        client={watch("client")?.id}
        onChange={handleLibraryChange}
        value={selectedLibraries}
        setValue={setValue}
        getValues={watch}
      />
      {isSubmitted && errors.libraries && (
        <small style={{ color: "red" }}>{errors.libraries.message}</small>
      )}
      {isSubmitted && errors.libraryConfigurations && (
        <small style={{ color: "red" }}>
          {errors.libraryConfigurations.message}
        </small>
      )}
    </div>
  );
}

export default LibraryMatchingFields;
